import { Routes } from '@angular/router';
import { personResolver } from '@app/resolvers/person.resolver';
import { providerResolver } from '@app/resolvers/provider.resolver';
import {
  faBuildingUser,
  faFileInvoice,
  faPeople,
  faPeopleSimple,
  faPersonDollyEmpty,
} from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const PERSONS_ITEMS: NavItem[] = [
  {
    label: 'Personas',
    icon: faPeopleSimple,
    iconSet: 'duo',
    roles: ['person_mngr'],
    children: [
      {
        label: 'Administración de Personas',
        icon: faPeople,
        iconSet: 'duo',
        roles: ['person_mngr'],
        routerLink: ['persons', 'admin-persons'],
      },
      {
        label: 'Administración de Proveedores',
        icon: faPersonDollyEmpty,
        iconSet: 'duo',
        roles: ['person_mngr'],
        routerLink: ['persons', 'admin-providers'],
      },
      {
        label: 'Administración de Operadores',
        icon: faBuildingUser,
        iconSet: 'duo',
        roles: ['person_mngr'],
        routerLink: ['persons', 'admin-operators'],
      },
      {
        label: 'Administración de Partidas',
        icon: faFileInvoice,
        iconSet: 'duo',
        roles: ['person_mngr'],
        routerLink: ['persons', 'admin-items'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'admin-items',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Administración de Partidas',
      roles: ['person_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./admin-items/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./admin-items/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.name || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'admin-operators',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Administración de Operadores',
      roles: ['person_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./admin-operators/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./admin-operators/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: providerResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.name || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'admin-persons',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Administración de Personas',
      roles: ['person_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./admin-persons/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./admin-persons/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: personResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.name || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'admin-providers',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Administración de Proveedores',
      roles: ['person_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./admin-providers/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./admin-providers/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: providerResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.name || 'Nuevo'}` },
        },
      },
    ],
  },
];
